<div class="card plan-card container-fluid" [ngClass]="plan.featured ? 'plan-card-featured': ''">
  <div class="row">
    <div class="col-8 col-md-3 border-right">
      <div class="row px-3">
        <div class="col-12 py-3 border-bottom text-center">
          <span class="d-block font-weight-bold font-size-md">{{plan.name}} [ID# {{plan.hfId}}]</span>
        </div>
      </div>
      <div class="row px-3">
        <div class="col-12 py-3 text-center">
          <span class="font-weight-bold font-size-lg text-success">${{plan.premium}}</span>
          <sup *ngIf="plan.hasDisclaimer" class="font-weight-bold font-size-md text-secondary">†</sup>
          <span class="d-block mt-1">{{'common.planItem.perMonth' | translate}}</span>
        </div>
      </div>
      <div class="row px-3 d-block d-md-none">
        <div class="col-12 py-3 border-top text-center">
          <a (click)="$event.preventDefault();showBenefitsModal()"
             href="#">{{'common.planItem.showBenefits' | translate}}
            <fa-icon [icon]="['far', 'clone']"></fa-icon>
          </a>
        </div>
      </div>
    </div>
    <div class="col-7 pt-3 d-none d-md-block">
      <div class="row">
        <div class="col-12"><span
            class="font-weight-bold font-size-md">{{'common.planItem.benefitsInclude' | translate}}</span></div>
      </div>
      <div class="row font-size-xs">
        <div *ngIf="plan?.benefits?.col1" class="col-6 pb-3">
          <ul class="m-0 pl-3">
            <li *ngFor="let benefit of plan.benefits.col1" class="pt-2">{{benefit}}</li>
          </ul>
        </div>
        <div *ngIf="plan?.benefits?.col2" class="col-6 pb-3">
          <ul class="m-0 pl-3">
            <li *ngFor="let benefit of plan.benefits.col2" class="pt-2">{{benefit}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-4 col-md-2 border-left align-self-center">
      <div class="row px-3 pt-3 pb-0">
        <div class="col-12 p-0">
          <button
              (click)="emitSelectedPlanEvent()"
              *ngIf="!selected"
              class="btn btn-block btn-success text-capitalize p-3">{{'common.buttonLabels.select' | translate}}</button>
          <button
              (click)="emitSelectedPlanEvent()"
              *ngIf="selected"
              class="btn btn-block btn-warning text-capitalize p-3">
            <fa-icon [icon]="['fas', 'check']"></fa-icon>
            <span
                *ngIf="plan.additionalBenefits?.length"
                class="badge badge-danger badge-pill border border-light">{{plan.additionalBenefits.length}}</span>
          </button>
        </div>
      </div>
      <div class="row p-3">
        <div class="col-12 p-0">
          <button
              (click)="showDownloadsModal()"
              class="btn btn-block btn-outline-success p-2 p-md-3">{{'common.buttonLabels.downloadPDF' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
